import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "new-chirp-div" }
const _hoisted_2 = { class: "new-chirp-box" }
const _hoisted_3 = { class: "new-chirp-input w-form" }
const _hoisted_4 = { class: "form-input-wrapper" }
const _hoisted_5 = { class: "form-input-wrapper" }
const _hoisted_6 = { class: "btns-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "new-chirp-box-title" }, "New Chirp", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "new-chirp-form-wrapper",
          onSubmit: _cache[4] || (_cache[4] = 
            (e) => {
              e.preventDefault();
              _ctx.createNewChirp({
                newChirpName: _ctx.newChirpName,
                newChirpDesc: _ctx.newChirpDesc,
              }).then((result) => {
                console.log('result', result);
                if (result.success === true) {
                  _ctx.$router.push(`/chirp/${result.id}`);
                  _ctx.setNewChirpDialog(false);
                }
              });
            }
          )
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              for: "email-3",
              class: "form-label"
            }, "Chirp Name", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "form-input w-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newChirpName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.newChirpName]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              for: "email-3",
              class: "form-label"
            }, "Chirp Description", -1)),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-input textarea w-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newChirpDesc) = $event))
            }, null, 512), [
              [_vModelText, _ctx.newChirpDesc]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "notification-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => {
                _ctx.createNewChirp({
                  newChirpName: _ctx.newChirpName,
                  newChirpDesc: _ctx.newChirpDesc,
                }).then((result) => {
                  console.log('result', result);
                  if (result.success === true) {
                    _ctx.$router.push(`/chirp/${result.id}`);
                    _ctx.setNewChirpDialog(false);
                  }
                })
              })
            }, " Create "),
            _createElementVNode("div", {
              class: "notification-btn cancel",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setNewChirpDialog(false)))
            }, " Cancel ")
          ])
        ], 32)
      ])
    ]),
    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"chirp-library-preview hidden\"><div class=\"chirp-preview-box\"><div class=\"chirp-preview-info\"><div class=\"chirp-preview-name\">GSAP Starter Chirp</div><div class=\"chirp-preview-by\">By ChirpJS</div><div class=\"chirp-preview-desc\"> Description:<br>A starter snippet for GSAP project. Created by ChirpJS and made available to public. </div></div><div class=\"chirp-preview-right\"><div class=\"chirp-preview-code-wrapper\"><div class=\"chirp-preview-code\"> Description:A starter snippet for GSAP pr<br>oject. Created by ChirpJS and made<br> available to p<br>ublic.Description:A starter snippet for GSAP project. Created by ChirpJS and made a<br>vailable to public.Description:A starter snippet for GS<br>AP project. Created by ChirpJS and made available to public.Description:A s<br>tarter snipp<br>et for GSAP project. Created by ChirpJS and made<br> available to public.Description:A starter snippet for GSAP project. Created by Chirp<br>JS and made available to public.Descri<br>ption:A starter snippet for GSAP proj<br>ect. Created by ChirpJS an<br>d made available to public.Description:A starter snippet for GSAP proj<br>ect. Crea<br>ted by ChirpJS and made available t<br>o public.Description:A starter snippet for GSAP project. Created by ChirpJS and made a<br>vailable to public.Description:A starter snippet for GSAP p<br>roject. Created by ChirpJS and made available to pu<br>blic.Description:A starter<br> snippet for GSAP project. C<br>reated by ChirpJS and m<br>ade available to public.Description:<br>A starter snippet for<br> GSAP project. Created<br> by ChirpJS and made availab<br>le to public.D<br>escription:A star<br>ter snippet for GSAP project. Created by ChirpJS and ma<br>de available to public.Description:A starter snippet for <br>GSAP project. Cre<br>ated by ChirpJS and m<br>ade available to public.Description:A starter <br>snippet for GSAP project. Created by ChirpJS an<br>d made available to public.<br>Description:A starter snippet for GSAP project. Created by C<br>hirpJS and made avail<br>able to pub<br>lic.Description:A starter snippet for GSAP project. Created by ChirpJS <br>and made avar GSAP <br>project. C </div><div class=\"chirp-preview-btns-wrapper\"><div class=\"notification-btn blue\">Clone</div><div class=\"notification-btn cancel\">Cancel</div></div></div></div></div></div>", 1))
  ]))
}